module.exports = __webpack_public_path__ + "assets/img/custom-sm.d8f947cd.jpg";